// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body[data-header-scroll=on] .topbar.has-background .btn.btn-icon:hover{background-color:hsla(0,0%,100%,.1)!important}body[data-header-scroll=on] .topbar.has-background .btn.btn-icon i{color:#fff!important}", ""]);
// Exports
module.exports = exports;
